<script setup lang="ts">
import { LMarker } from '@vue-leaflet/vue-leaflet';

defineProps<{
    coordinates: { latitude: number; longitude: number };
}>();

const emit = defineEmits<{
    mouseover: [event: any];
    click: [event: any];
    mouseleave: [event: any];
}>();
const markerRef = ref<InstanceType<typeof LMarker>>();

const closePopup = () => {
    markerRef.value?.leafletObject?.closePopup();
};
defineExpose({
    markerRef,
});
const slots = useSlots();
</script>
<template>
    <LMarker
        ref="markerRef"
        :lat-lng="[coordinates?.latitude || 0, coordinates.longitude || 0]"
        @mouseover="emit('mouseover', $event)"
        @click="emit('click', $event)"
    >
        <l-icon
            v-if="slots.icon"
            class-name="custom-icon-marker"
            :popup-anchor="[0, 8]"
        >
            <slot name="icon" />
        </l-icon>
        <l-popup v-if="slots.popup" ref="popup" class="popup-content">
            <slot name="popup" :close="closePopup" />
        </l-popup>
    </LMarker>
</template>

<style lang="scss">
.leaflet-popup-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>
